import React from 'react';
import './nav.scss';

import {
  Link, withRouter
} from "react-router-dom";
import About from '../about/About';
import TheDancer from '../dancer/Dancer';
import Exhibitions from '../exhibitions/Exhibitions';
import Home from '../home/Home';
import Identity from '../identity/Identity';
import IdentityCards from '../identity-cards/IdentityCards';
import Repository from '../repository/Repository';
import TwoCountries from '../two-countries/TwoCountries';
import { faArrowLeft, faHandPointer, faInfo, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { red } from '../styles';
import { MediaQueryContext } from '../MediaQueryContext';
import NavBackground from './nav-background.svg';
import FullPoem from '../full-poem/FullPoem';
import aboutBackground from '../images/about-background-1.jpg';
import exhibitionsBackground from '../images/exhibitions-background.jpg';
import twoBackground from '../images/two-countries-background.jpg';
import dancer from '../images/dance-background.jpg';
import fullPoemBackground from '../images/poem-background.jpg';
import identityBackground from '../images/inam-background.jpg';
import repoBackground from '../images/portrait-background.jpg';
import cardsBackground from '../images/cards-background.jpg'

export const routes = [
  { path: "/", label: "Home", Component: Home, excludes: ['/stations'] },
  { path: "/stations", excludes: ['/stations'], label: "Exhibitions", Component: Exhibitions },
  { path: "/about", label: "About", Component: About, backgroundImage: `url(${aboutBackground})`, description: "The audio-visual exhibition Skin Remembers: stories and identities of the few", descriptionNorwegian: "Om den audiovisuelle utstillingen Skin Remembers" },
  { path: "/two-countries", label: "Two Countries", Component: TwoCountries, backgroundImage: `url(${twoBackground})`, description: "Exploring multiple identities through poetry and animation", descriptionNorwegian: "Utforsk mangfoldige identiteter gjennom poesi og animasjon" },
  { path: "/repository", label: "Repository", Component: Repository, backgroundImage: `url(${repoBackground})`, description: "Projected portrait photography of three individuals from varied minority groups: Kurdish, LGBTQ+ and Palestinian", descriptionNorwegian: "Prosjekterte portrett fotografier av tre individer med ulike minoritetsbakgrunner: kurdisk, LHBTI+ og Palestinsk" },
  { path: "/dance-and-identity", label: "Dance and Identity", Component: TheDancer, backgroundImage: `url(${dancer})`, description: "Meet a dancer and a stage performer who express their identities through dance and bodily movements", descriptionNorwegian: "Møt en danser og en scenekunstner som uttrykker sine identiteter gjennom dans og kroppslig bevegelse" },
  { path: "/what-about-identity", label: "What About Identity?", Component: Identity, backgroundImage: `url(${identityBackground})`, description: "Portrait interviews of three people with a minority and refugee background", descriptionNorwegian: "Portrett intervjuer av tre mennesker med flyktning- og minoritetsbakgrunn" },
  { path: "/identity", label: "What does identity mean to you?", Component: IdentityCards, backgroundImage: `url(${cardsBackground})`, description: "Take a look at what some of the viewers from the physical exhibition (held at ARKIVET summer of 2019) were thinking and feeling about identity ", descriptionNorwegian: "Ta en titt på hva noen av de besøkende av den fysiske utstillingen (holdt på ARKIVET sommeren 2019) tenkte og følte om identitet" },
  { path: "/full-poem", label: "Poem", Component: FullPoem, backgroundImage: `url(${fullPoemBackground})`, description: "Read the full poem “Two Countries” by Naomi Shihab Nye", descriptionNorwegian: "Les hele diktet “Two Countries” av Naomi Shihab Nye" },
];

class Nav extends React.Component {
  static contextType = MediaQueryContext;
  constructor() {
    super();
    this.state = { open: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((state) => ({ open: !state.open }));

  }

  render() {
    if (!this.context.isDesktop && this.props.location.pathname === '/') {
      return null;
    }

    let style = {};
    if (this.context.isMobile) {
      // style.backgroundImage = `url(${NavBackground})`
    }

    return (
      <nav style={style}>
        {this.context.isMobile && <div className="mobile-nav-background" style={{ background: 'linear-gradient(0deg,rgba(0,0,0,1) 11%, rgba(0,0,0,0) 93%)' }} ><img src={NavBackground} /></div>}
        <button onClick={this.toggle}>MENU</button>
        <CSSTransition timeout={300} classNames="menu" in={this.state.open} mountOnEnter={true} unmountOnExit={true}>
          <ul onClick={this.toggle} className="menu">
            <li><Link to="/"><FontAwesomeIcon color={red} icon={faArrowLeft} /><span>FRONT PAGE</span></Link></li>
            <li><Link to="/full-poem"><FontAwesomeIcon color={red} icon={faQuoteLeft} /><span>READ POEM</span></Link></li>
            <li><Link to="/stations"><FontAwesomeIcon color={red} icon={faHandPointer} /><span>CHOOSE STATION</span></Link></li>
            <li><Link to="/about"><FontAwesomeIcon color={red} icon={faInfo} /><span>ABOUT</span></Link></li>
            <li><a href="https://beheard.no"><FontAwesomeIcon color={red} icon={faQuoteLeft} /><span>BEHEARD.NO</span></a></li>

          </ul>
        </CSSTransition>

      </nav>
    );
  }
}

export default withRouter(Nav);
